export type CreatedForRelationCandidate = {
  direction: string;
  itemId?: string;
  mediaRole?: string;
  object: { name: string; path: string };
  objectAnchor?: string;
  objectRevisionState?: string;
  relation: string;
  subject: { path: string };
};

export type CreatedForMediaContext = {
  anchor?: string;
  contextChanged: boolean;
  documentName: string;
  documentPath: string;
  itemId?: string;
  mediaRole?: string;
};

export function selectCreatedForMediaContext(args: {
  relations: CreatedForRelationCandidate[];
  sourcePath: string;
}): CreatedForMediaContext | null {
  const relation = args.relations.find(
    (candidate) =>
      candidate.relation === 'created-for' &&
      candidate.direction === 'outgoing' &&
      candidate.subject.path === args.sourcePath
  );
  if (!relation) return null;
  return {
    contextChanged: relation.objectRevisionState === 'changed',
    documentName: relation.object.name.slice(0, 240),
    documentPath: relation.object.path,
    ...(relation.itemId ? { itemId: relation.itemId } : {}),
    ...(relation.mediaRole ? { mediaRole: relation.mediaRole } : {}),
    ...(relation.objectAnchor ? { anchor: relation.objectAnchor } : {}),
  };
}

export function naturalDocumentName(name: string): string {
  return name
    .replace(/\.mdx?$/i, '')
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 120);
}

export function mediaContextCtaKind(args: {
  hasContext: boolean;
  hasResearch: boolean;
}): 'research-and-rationale' | 'context-and-rationale' | 'rationale' {
  if (args.hasResearch) return 'research-and-rationale';
  if (args.hasContext) return 'context-and-rationale';
  return 'rationale';
}

export function shouldShowLinkedSectionNotice(args: {
  contextChanged: boolean;
  documentLoaded: boolean;
  itemResolved: boolean;
  targetItemId?: string;
}): boolean {
  return Boolean(
    args.contextChanged &&
      args.documentLoaded &&
      args.targetItemId &&
      !args.itemResolved
  );
}
